import { useCallback, useState } from "react";
import { mergeSignalRMessage } from "../../../utils/helpers";

export default function useFeedbackDialog({ service, activeDraft, setDraft }) {
  const [feedbackDialogOpen, setFeedbackDialogOpen] = useState(false);
  const [isFeedbackSending, setIsFeedbackSending] = useState(false);
  const [isFeedbackDeleting, setIsFeedbackDeleting] = useState(false);

  const openFeedbackDialog = useCallback(() => {
    if (!activeDraft) {
      return;
    }
    setFeedbackDialogOpen(true);
  }, [activeDraft]);

  const closeFeedbackDialog = useCallback(() => {
    if (isFeedbackSending) {
      return;
    }
    setFeedbackDialogOpen(false);
  }, [isFeedbackSending]);

  const submitFeedback = useCallback(async (payload) => {
    setIsFeedbackSending(true);
    try {
      const result = await service.submitFeedback(payload);
      if (result) {
        setDraft((prev) => prev ? { ...prev, feedbacks: mergeSignalRMessage(prev.feedbacks, result) } : prev);
      }
    } finally {
      setIsFeedbackSending(false);
    }
  }, [service, setDraft]);

  const deleteFeedback = useCallback(async (feedbackId) => {
    setIsFeedbackDeleting(true);
    try {
      const success = await service.deleteFeedback(feedbackId);
      if (success) {
        setDraft((prev) => prev ? { ...prev, feedbacks: (prev.feedbacks ?? []).filter((f) => f.id !== feedbackId) } : prev);
      }
    } finally {
      setIsFeedbackDeleting(false);
    }
  }, [service, setDraft]);

  return {
    feedbackDialogOpen,
    isFeedbackSending,
    isFeedbackDeleting,
    openFeedbackDialog,
    closeFeedbackDialog,
    submitFeedback,
    deleteFeedback,
  };
}
